<template>
  <div class="menuexpansionDoc">
    <div>
      <h1 class="subhead">MENU EXPANSION 1 LEVEL</h1>
    </div>
      <menu-expansion :lists="lists" @selected="selected"/>
    <div>
      <h1 class="subhead">MENU EXPANSION 2 LEVEL WITH STATUS</h1>
    </div>
    <menu-expansion-status :lists="menuList" @selected="selected"/>
  </div>
</template>

<script>
import MenuExpansion from '@/components/MenuExpansion'
import MenuExpansionStatus from '@/components/MenuExpansionStatus'


export default {
  name: 'adx-menu-expansion-docs',
  components: {
    'menu-expansion': MenuExpansion,
    'menu-expansion-status': MenuExpansionStatus
  },
  data(){
    return {
      lists: [ 
        {
          'id': 0,
          'name': 'Gaul',
          'value': 'GA',
        },
        {
          'id': 1,
          'name': 'Jadul',
          'value': 'JA'
        },
        {
          'id': 2,
          'name': 'Konser',
          'value': 'KO'
        },
        {
          'id': 3,
          'name': 'Nobar',
          'value': 'NO'
        },
        {
          'id': 4,
          'name': 'Seminar',
          'value': 'SE'
        },
      ],
      menuList: [ 
        {
          "id": 0,
          "name": "Change Progress",
          "value": "S",
          "items": [
            {
              'label': 'Designing',
              'value': 'designing'
            },
            {
              'label': 'Verifying',
              'value': 'verifying'
            },
            {
              'label': 'Validating',
              'value': 'validating'
            },
            {
              'label': 'Wrapping',
              'value': 'wrapping'
            },
            {
              'label': 'Done',
              'value': 'done'
            },
          ]
        },
        {
          "id": 1,
          "name": "View Detail",
          "value": "AP",
        },
      ],
    }
  },
  methods: {
    selected(item){
      
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>